import type { FunctionComponent } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Components
import Header from "../components/header/header.component";
import Loading from "../components/loading/loading.component";
import { useAppSelector } from "../hooks/redux.hooks";

const AuthenticationGuard: FunctionComponent = ({ children }) => {
	const { isAuthenticated } = useAppSelector((state) => state.userReducer);

	const navigate = useNavigate();

	useEffect(() => {
		if (!isAuthenticated) {
			setTimeout(() => {
				navigate("/login");
			}, 3000);
		}
	}, [isAuthenticated, navigate]);

	if (!isAuthenticated) {
		return (
			<>
				<Header />
				<Loading message="Você precisa estar logado para acessar esta página. Você será redirecionado para a página de login em instantes..." />
			</>
		);
	}

	return <>{children}</>;
};

export default AuthenticationGuard;
